export { buildNode } from "./buildNode";
export type { BuildNodeParams } from "./buildNode";

export {
  missingNodeProperties,
  missingRecommendedRichResultProperties,
  missingRichResultProperties,
  notesFor,
  propertiesForTypes,
  recipeFor,
  resolveTypeChain,
  recommendedRichResultProperties,
  richResultProperties,
  selectableTypes,
} from "./catalog";
export type { CatalogProperty, CatalogType } from "./catalog";

export { structuredDataRelationIds, validateConfig } from "./config";
export type {
  ConfigProblem,
  StructuredDataConfig,
  StructuredDataFieldMapping,
} from "./config";

export {
  nativeEntryFieldNames,
  nativeEntryFields,
  nativeEntryFieldTypes,
} from "./nativeEntryFields";
export type { NativeEntryField } from "./nativeEntryFields";

export { googleRules } from "./googleRules";
export { recipes } from "./recipes";
export { containers, vocabulary } from "./vocabulary";

export { CONTENT_FIELD_TYPES } from "./types";
export type {
  CatalogBrand,
  CatalogUnit,
  Container,
  ContentFieldTypeName,
  EmitContext,
  Emitter,
  GoogleRule,
  Recipe,
  VocabularyEntry,
} from "./types";
